<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Locations</b>
        <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="showCreateLocationModal = true">
          <span class="button-text">Add Location</span>
        </b-button>
      </b-card-header>

      <!-- List organization Locations -->
      <div v-if="formatLocations && formatLocations.length > 0">
        <b-list-group v-for="location in formatLocations" :key="location.id" flush>
          <b-list-group-item>
            <a href="#" @click.prevent="showUpdateLocationMod(location)">
              {{location.title}}
            </a>
            <img v-if="defaultLocationId == location.id " src="static/img/Primary.png" height="21" width="21">
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="formatLocations.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>
              {{ !hasLocations ? 'This Organization does not have any Locations.' : 'Howdy!' }}
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <CreateLocationModal
      :showModal.sync="showCreateLocationModal"
      :organizationId="organizationId"
      :orgLocations="orgLocations"
    >
    </CreateLocationModal>

    <UpdateLocationModal
      :showModal.sync="showUpdateLocationModal"
      :organizationId="organizationId"
      :selectedLocationRec="selectedLocationRec"
      :orgLocations="orgLocations"
      :disableDelete="disableDeleteVar"
    >
    </UpdateLocationModal>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CreateLocationModal from '@/components/Admin/CreateLocationModal'
  import UpdateLocationModal from '@/components/Admin/UpdateLocationModal'
  const MAX_ARRAY_LIMIT = 30

  export default {
    name: 'OrganizationLocations',
    props: {
      organizationId: Number,
      defaultLocation: String,
      locations: Array
    },
    components: {
      CreateLocationModal,
      UpdateLocationModal
    },
    data: function () {
      return {
        showCreateLocationModal: false,
        showUpdateLocationModal: false,
        selectedLocation: null,
        disableDeleteVar: true,
        defaultLocationId: this.defaultLocation,
        selectedLocationRec: null
      }
    },
    computed: {
      hasLocations: function () {
        return this.formatLocations.length > 0
      },
      ...mapGetters({
        updateOrganization: 'getUpdateOrganizationSuccess',
        orgLocations: 'getLocationsByOrg'
      }),
      formatLocations () {
        const locations = this.locations.length < MAX_ARRAY_LIMIT ? this.locations : this.orgLocations
        return locations.filter((loc) => !loc.isRemoved)
      }
    },
    watch: {
      updateOrganization (newValue) {
        if (newValue) {
            this.defaultLocationId = newValue.defaultLocation
        }
      },
      async locations (newValue) {
        if (newValue.length >= MAX_ARRAY_LIMIT) {
          await this.$store.dispatch('getLocationsByOrg', { orgId: this.organizationId })
        }
      }
    },
    async mounted () {
      if (this.locations.length >= MAX_ARRAY_LIMIT) {
        await this.$store.dispatch('getLocationsByOrg', { orgId: this.organizationId })
      }
    },
    methods: {
      showUpdateLocationMod (locationRec) {
        this.disableDeleteVar = true
        this.selectedLocationRec = locationRec
        this.showUpdateLocationModal = true
      }
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Admin/LocationList.vue